"use client"

import { useState, useEffect } from "react"
import { getFooterText } from "@/lib/admin-config"

export function AppFooter() {
  const [text, setText] = useState(() => getFooterText())

  useEffect(() => {
    const onUpdate = () => setText(getFooterText())
    window.addEventListener("crm_admin_settings_updated", onUpdate)
    return () => window.removeEventListener("crm_admin_settings_updated", onUpdate)
  }, [])

  if (!text || !text.trim()) return null

  return (
    <footer className="mt-auto border-t border-border/50 bg-background/80 py-2 px-4 text-center">
      <p className="text-xs text-muted-foreground">
        {text}
      </p>
    </footer>
  )
}

export default AppFooter
